// Small marks shared by the environment list and detail: the status dot and an allocation bar.
import { useT } from "../../i18n";
import { DotStatus } from "../../ui/status";
import { environmentTone, statusLabel } from "../../ui/tones";

const BUSY = new Set(["requested", "provisioning", "configuring_network", "deleting"]);

export function EnvironmentStatus({ status }: { status: string }) {
  // Re-render on a language change: statusLabel reads the active messages.
  useT();
  return (
    <DotStatus
      tone={environmentTone(status)}
      pulse={BUSY.has(status)}
      label={<span className="inline-block first-letter:uppercase">{statusLabel(status)}</span>}
    />
  );
}

/** A limit as a share of the organisation's quota. */
export function Allocation({ value, of, unit }: { value: number; of: number | undefined; unit: string }) {
  const t = useT().workloads.environment;
  const pct = of ? Math.min(100, (value / of) * 100) : 0;
  return (
    <div className="w-32">
      <div className="tabular text-[13px] text-gray-700">
        <span className="font-semibold text-gray-900">{value}</span>
        {of ? ` / ${of}` : ""} {unit}
      </div>
      {of ? (
        <div className="mt-1.5 h-1.5 rounded-full bg-gray-100" title={t.quotaShare}>
          <div className="h-full rounded-full bg-primary" style={{ width: `${Math.max(pct, 1.5)}%` }} />
        </div>
      ) : null}
    </div>
  );
}
